import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';


class DeleteModal extends React.Component {

    constructor(props, context) {
        super(props, context);
    }

    // EVENT HANDLERS

    handleClose = () => {
        this.props.handleClose();
    }

    handleConfirm = () => {
        this.props.handleConfirm();
        this.props.handleClose();
    }

    // RENDER METHOD

    render = () => {
        return (
            <Modal show={true} className="modal fade" id="myModal4" tabIndex="-1" role="dialog" aria-labelledby="myModal4Label" aria-hidden="true">
                <div className="modal-dialog new-log-entry">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title" id="myModalLabel">Delete floating task</h4>
                        </div>
                        <div className="modal-body">
                            <span>
                                Floating task {this.props.taskName} has related log entries which will be deleted <br/><br/>
                                Are you sure you want to delete this floating task?
                            </span>
                        </div>
                        <div className="modal-footer">
                            <button title="Delete floating task" ref="deleteButton" type="button" className="btn btn-default btn-large" onClick={this.handleConfirm}>Delete</button>
                            <button title="Cancel delete" ref="closeButton" type="button" className="btn btn-default btn-discrete" onClick={this.handleClose}>Cancel</button>
                        </div>
                    </div>
                </div>
            </Modal>

        );
    }
}

DeleteModal.propTypes = {
    taskName: PropTypes.string,
    handleClose: PropTypes.func,
    handleConfirm: PropTypes.func,
};

export default connect()(DeleteModal);



/** WEBPACK FOOTER **
 ** ./src/app/components/DeleteModal.js
 **/